export enum ActivityName {
    TEMPERATURE = 'temperature',
    BLOOD_PRESSURE = 'blood_pressure',
    SPO2 = 'spo2',
    HEART_RATE = 'heart_rate',
    WEIGHT = 'weight',
    ECG = 'ecg',
    STEP = 'step',
    DYSPNEA = 'dyspnea',
    SPIROMETRY = 'spirometry',
}

export enum MeasurementName {
    TEMPERATURE = 'temperature',
    DIASYSTOLIC = 'diastolic',
    SYSTOLIC = 'systolic',
    HEART_RATE = 'heartRate',
    SPO2 = 'saturation',
    WEIGHT = 'weight',
    ECG = 'ecg',
    STEP = 'step',
    DYSPNEA = 'dyspnea',
    PEF = 'pef',
}

export enum MeasurementUnit {
    TEMPERATURE = '°C',
    DIASYSTOLIC = 'mmHg',
    SYSTOLIC = 'mmHg',
    HEART_RATE = 'bpm',
    SPO2 = '%',
    WEIGHT = 'Kg',
    ECG = 'mV',
    STEP = 'step',
    DYSPNEA = 'dyspnea',
    PEF = 'L/m',
}

export type TMeasurementName = "temperature" | "diastolic" | "systolic" | "heartRate" | "saturation" | "weight" | "ecg" | "step" | "dyspnea" | "pef";

export type TDrugIntakeReason = 'forgot' | 'side_effects' | 'ran_out' | 'felt_better' | 'doctor_instructed' | 'other';

export type TDrugSlot = 'morning' | 'afternoon' | 'evening';

export interface IDrugIntakeRequest {
    administered: boolean;
    actual_window?: TDrugSlot;
    reasons?: TDrugIntakeReason[];
    note?: string;
}

export interface IQuestionnaireRequest {
  answers: Array<{
    question_id: string;
    selected_option_ids: string[];
    free_text: string | null;
  }>;
}